import './App.scss';
import Header from './components/header';
import Footer from './components/footer';
import { Route, Routes} from "react-router-dom";
import Home from './pages/home';
import ErrorPage from './pages/errorPage';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';


function App() {
  useEffect(() => {
    AOS.init({
      duration: 2500
    });
  }, [])
  return (
    <div className="site-wrapper">
      <Header />
      <main className="site-content">
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='*' element={<ErrorPage to="/" />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
